import type { User } from '@closetly/core';
import { useState } from 'react';
import { useMembership, type SaveTarget } from '../lib/membership';
import { Sheet } from './Sheet';

/** "Merken": put a piece on boards and into outfits, or an outfit on boards. Changes apply at once. */
export function SaveSheet({ user, target, onClose }: { user: User; target: SaveTarget; onClose: () => void }) {
  const m = useMembership(user.id);
  const [name, setName] = useState('');

  function create() {
    if (!name.trim()) return;
    m.createBoard(name, target);
    setName('');
  }

  return (
    <Sheet open onClose={onClose} onSubmit={onClose} labelledBy="saveTitle">
      <h2 id="saveTitle">Merken</h2>
      <p className="hint">{target.name}</p>

      <div className="field">
        <span className="label">Boards</span>
        <div className="chips wrap-chips" role="group" aria-label="Boards">
          {m.boards.map((b) => {
            const on = m.inBoard(b, target);
            return (
              <button key={b.id} type="button" className="chip" aria-pressed={on} onClick={() => m.setBoard(b, target, !on)}>
                {b.name}
              </button>
            );
          })}
        </div>
        <div className="linkrow new-board">
          <input
            value={name}
            onChange={(e) => setName(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                e.preventDefault();
                create();
              }
            }}
            placeholder="Neues Board, z. B. Herbst"
            aria-label="Name für ein neues Board"
            maxLength={60}
          />
          <button type="button" className="btn" disabled={!name.trim()} onClick={create}>
            Anlegen
          </button>
        </div>
      </div>

      {target.type === 'item' && m.outfits.length > 0 && (
        <div className="field">
          <span className="label">Outfits</span>
          <div className="chips wrap-chips" role="group" aria-label="Outfits">
            {m.outfits.map((o) => {
              const on = m.inOutfit(o, target);
              return (
                <button
                  key={o.id}
                  type="button"
                  className="chip"
                  aria-pressed={on}
                  onClick={() => m.setOutfit(o, target.id, !on)}
                >
                  {o.name || 'Outfit ohne Namen'}
                </button>
              );
            })}
          </div>
        </div>
      )}

      <div className="sheet-actions">
        <div className="right">
          <button type="submit" className="btn ink">
            Fertig
          </button>
        </div>
      </div>
    </Sheet>
  );
}
